/**
 * Silences episode narration while the viewer talks to the Agent or hears its reply.
 * Playback and subtitles continue; only the narration audio is muted.
 */
export type NarrationSilence = {
    isSilenced: () => boolean;
    subscribe: (listener: () => void) => () => void;
};

export function createNarrationSilence() {
    const reasons = new Set<string>();
    const listeners = new Set<() => void>();
    return {
        isSilenced: () => reasons.size > 0,
        subscribe(listener: () => void) {
            listeners.add(listener);
            return () => { listeners.delete(listener); };
        },
        /** Sets or clears one owner's reason; narration stays silent while any reason is set. */
        set(reason: string, silenced: boolean) {
            const before = reasons.size > 0;
            if (silenced) reasons.add(reason);
            else reasons.delete(reason);
            if (before !== reasons.size > 0) listeners.forEach(listener => listener());
        },
    };
}

export const narrationSilence = createNarrationSilence();
